import React from 'react'
import PropTypes from 'prop-types'

import style from './style.module.scss'

Columns.propTypes = {
  children: PropTypes.node,
}

function Columns(props) {
  const { children } = props

  return <div className={style.wrapper}>{children}</div>
}

export default Columns
